import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';

const save = ({ attributes }) => {
    const { imageUrl, backgroundColor, position } = attributes;
    const blockProps = useBlockProps.save({ className: 'custom-slide swiper-slide' });

    return (
        <div {...blockProps}>
            <div className="slide-preview">
                {imageUrl && <img src={imageUrl} alt="Slide" />}
                <div className="wrapper-group">
                    <div className={`inner-group ${position}`} style={{ width: '50%' , backgroundColor }}>
                        <InnerBlocks.Content />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default save;
